import React, { useCallback, useEffect } from 'react';
import "./StekView.css"
import { stek_render } from './stek/sk-rendering';

const testPixelRatio = window.devicePixelRatio;

function StekView(props) {
	const canvasRef = React.useRef(null);
	const render = useCallback( () => {
		if (canvasRef.current && props.stekContext) {
			resize_canvas(canvasRef.current);
			stek_render(canvasRef.current, props.stekContext, props.project, testPixelRatio);
		}	
	}, [canvasRef, props]);

	const onPointerDown = useCallback( e => {
		if (canvasRef.current) {
			props.viewController?.onPointerDown?.(e, canvasRef.current);
		}
	}, [canvasRef, props]);

	const onPointerMove = useCallback( e => {
		props.viewController?.onPointerMove?.(e);
	}, [props]);

	const onPointerUp = useCallback( e => {
		if (canvasRef.current) {
			props.viewController?.onPointerUp?.(e, canvasRef.current);
		}
	}, [canvasRef, props]);

	useEffect( () => {
		const canvas = canvasRef.current;
		if (canvas) {
			render();
		}

		return () => {
			// Clean up

		};
	});

	render();
	return (<div className="bd-stekview"><canvas
		onPointerDown={ onPointerDown }
		onPointerMove={ onPointerMove }
		onPointerUp={ onPointerUp }
		ref={ canvasRef }
	></canvas></div>);
}

function resize_canvas(canvas) {
	const pn = canvas.parentNode;
	if (pn) {
		const vw = pn.clientWidth;
		const vh = pn.clientHeight;

		const desiredW = vw * testPixelRatio;
		const desiredH = vh * testPixelRatio;
		if (is_near_size(canvas.width, desiredW) && is_near_size(canvas.height, desiredH)) {
			// don't resize
		} else {
			canvas.width = desiredW;
			canvas.height = desiredH;

			const s = canvas.style;
			s.width = `${vw}px`;
			s.height = `${vh}px`

	//console.log("RESIZE");
		}
	}
}

function is_near_size(a, b) {
	const d = Math.abs(a - b);
	return d < 0.1;
}

export default StekView;